import { z } from "zod";
import { OrganizationIdNameLogoUrlSchema } from "@common/schemas/organization.schema";
import { REPORT_SETTINGS_REPORT_KEYS } from "@common/types/reports/report-settings-report-key";
import { layoutOwnValuesSchema } from "./layout-setting.schema";
import { numberFormatOwnValuesSchema } from "./number-format-setting.schema";
import { reportSettingsOwnerSchema } from "./report-settings-owner.schema";

export const workspaceReportSettingsRowSchema = z.object({
    owner: reportSettingsOwnerSchema,
    reportKey: z.enum(REPORT_SETTINGS_REPORT_KEYS),
    ...layoutOwnValuesSchema.shape,
    ...numberFormatOwnValuesSchema.shape,
});
export type WorkspaceReportSettingsRow = z.infer<
    typeof workspaceReportSettingsRowSchema
>;

export const reportTemplateRefSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const appliedReportTemplateSchema = z.object({
    id: z.string().nullable(),
    name: z.string(),
});

export const workspaceReportSettingsEntitySchema = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    canEdit: z.boolean(),
    template: appliedReportTemplateSchema.optional(),
});

export const workspaceReportSettingsResponseSchema = z.object({
    rows: z.array(workspaceReportSettingsRowSchema),
    entities: z.array(workspaceReportSettingsEntitySchema),
    isManagedByFirm: z.boolean(),
    workspaceTemplate: appliedReportTemplateSchema.optional(),
    firmDefaultTemplate: reportTemplateRefSchema.optional(),
    brandingFirm: OrganizationIdNameLogoUrlSchema.nullable(),
});
export type WorkspaceReportSettingsResponse = z.infer<
    typeof workspaceReportSettingsResponseSchema
>;
